import { rem } from 'polished';
import styled from 'styled-components';
import { media } from '@luigiclaudio/ga-baseline-ui/layout';

const AddColorDefaultModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    padding: ${rem(8)};

    ${media.xs`
        padding: ${rem(8)} ${rem(16)};
    `}
`;

export default AddColorDefaultModalContainer;
